import React from 'react';

const AboutAreaNine = () => {
  return (
    <>
      {/* about area start */}
      <div className="about-area about-area_9 bg-black-ico pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div
                className="about-thumb-inner pe-xl-5 me-xl-5 wow animated fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-delay="0.3s"
              >
                <img
                  className="main-img"
                  src="assets/img/home-9/4.png"
                  alt="img"
                />
              </div>
            </div>
            <div
              className="col-lg-6 wow animated fadeInRight"
              data-wow-duration="1.5s"
              data-wow-delay="0.3s"
            >
              <div className="section-title mt-5 mt-lg-0">
                <h6 className="sub-title line-after text-white mb-3">
                  About US
                </h6>
                <h2 className="title text-white">
                  The Future Of Finance Is Decentralized
                </h2>
                <p className="content mb-4">
                  Business consulting services can ra from strategy development,
                  financial planning, marketing, human resour management, and
                  operations improvement. Consultants may also provide
                  specialized expertise in areas such as technology
                </p>
                <div className="row">
                  <div className="col-lg-6">
                    <ul className="p-0 single-list-inner style-left-line text-white style-check">
                      <li>
                        <img
                          className="me-2"
                          src="assets/img/home-9/5.png"
                          alt="img"
                        />{' '}
                        Block chain Boost
                      </li>
                      <li>
                        <img
                          className="me-2"
                          src="assets/img/home-9/5.png"
                          alt="img"
                        />{' '}
                        Invest Shield
                      </li>
                      <li>
                        <img
                          className="me-2"
                          src="assets/img/home-9/5.png"
                          alt="img"
                        />{' '}
                        Crypto Secure
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <ul className="p-0 single-list-inner style-left-line text-white style-check">
                      <li>
                        <img
                          className="me-2"
                          src="assets/img/home-9/5.png"
                          alt="img"
                        />{' '}
                        Mistakes To Avoid
                      </li>
                      <li>
                        <img
                          className="me-2"
                          src="assets/img/home-9/5.png"
                          alt="img"
                        />{' '}
                        Your Startup
                      </li>
                      <li>
                        <img
                          className="me-2"
                          src="assets/img/home-9/5.png"
                          alt="img"
                        />{' '}
                        Knew About Fonts
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* about area end */}
    </>
  );
};

export default AboutAreaNine;
